import type { FilterDefModifierConfig } from "./typings"

export const createFilterModifierConfig = <
	TValue,
	TFilterValue,
	TSerializedFitlerValue,
	TModifierValue extends TValue,
	TModifierFilterValue extends TFilterValue,
	TSerializedModifierFilterValue extends TSerializedFitlerValue,
>(
	conifg: FilterDefModifierConfig<
		TValue,
		TFilterValue,
		TSerializedFitlerValue,
		TModifierValue,
		TModifierFilterValue,
		TSerializedModifierFilterValue
	>,
) => conifg
